export const SET_ISSUES_DATA = "SET_ISSUES_DATA";
export const SET_ISSUES_LOADING = "SET_ISSUES_LOADING";
export const SET_ISSUES_PAGINATION = "SET_ISSUES_PAGINATION";
export const SET_ISSUES_FILTER = "SET_ISSUES_FILTER";
export const SET_ISSUES_SINGLE = "SET_ISSUES_SINGLE";
export const RESET_ISSUES_REDUCER = "RESET_ISSUES_REDUCER";

